/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TopGuildLeaderboard
 */
export interface TopGuildLeaderboard {
    /**
     * 
     * @type {string}
     * @memberof TopGuildLeaderboard
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof TopGuildLeaderboard
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof TopGuildLeaderboard
     */
    totalPoints: number;
    /**
     * 
     * @type {number}
     * @memberof TopGuildLeaderboard
     */
    rank?: number;
}

/**
 * Check if a given object implements the TopGuildLeaderboard interface.
 */
export function instanceOfTopGuildLeaderboard(value: object): value is TopGuildLeaderboard {
    if (!('totalPoints' in value) || value['totalPoints'] === undefined) return false;
    return true;
}

export function TopGuildLeaderboardFromJSON(json: any): TopGuildLeaderboard {
    return TopGuildLeaderboardFromJSONTyped(json, false);
}

export function TopGuildLeaderboardFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopGuildLeaderboard {
    if (json == null) {
        return json;
    }
    return {
        
        'icon': json['icon'] == null ? undefined : json['icon'],
        'name': json['name'] == null ? undefined : json['name'],
        'totalPoints': json['totalPoints'],
        'rank': json['rank'] == null ? undefined : json['rank'],
    };
}

export function TopGuildLeaderboardToJSON(json: any): TopGuildLeaderboard {
    return TopGuildLeaderboardToJSONTyped(json, false);
}

export function TopGuildLeaderboardToJSONTyped(value?: TopGuildLeaderboard | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'icon': value['icon'],
        'name': value['name'],
        'totalPoints': value['totalPoints'],
        'rank': value['rank'],
    };
}

